import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    group: {
        flexDirection: "column"
    }
});
export default stylesheet;
